import { render, staticRenderFns } from "./Venta.vue?vue&type=template&id=32ff462d&"
import script from "./Venta.vue?vue&type=script&lang=js&"
export * from "./Venta.vue?vue&type=script&lang=js&"
import style0 from "./Venta.vue?vue&type=style&index=0&id=32ff462d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports